import {Container, Stack} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type * as React from 'react';
import {SignInButton} from '@/components/MSAL/ui-components/SignInButton';

const LoginDisplay = () : React.ReactElement => {
    return <Container>
        <CssBaseline/>
        <AppBar position="fixed">
            <Toolbar>
                <Typography variant="h6" noWrap component="div" sx={{flexGrow: 1}}>
                    Capacity Planner
                </Typography>
                <SignInButton/>
            </Toolbar>
        </AppBar>
        <Stack
            sx={{
                pt: '60px',
                mt: '60px',
            }}
        >
            <Typography variant="h6" align="center">Please login to see capacity information.</Typography>
        </Stack>
    </Container>;
};

export default LoginDisplay;
